import Vue from "vue";
import VueRouter from "vue-router";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import axios from "axios"

import App from "./App.vue";
import routes from "./routes";

axios.defaults.baseURL = 'https://expan-one-lfw4jdwenq-ew.a.run.app/gateway/api/v1/'
// Install vue router
Vue.use(VueRouter);

// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

Vue.config.productionTip = false;

const router = new VueRouter({ mode: "history", routes });

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
